import { render, staticRenderFns } from "./NetpaUploader.vue?vue&type=template&id=18d8245d&scoped=true&"
import script from "./NetpaUploader.vue?vue&type=script&lang=js&"
export * from "./NetpaUploader.vue?vue&type=script&lang=js&"
import style0 from "./NetpaUploader.vue?vue&type=style&index=0&id=18d8245d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8245d",
  null
  
)

export default component.exports